import { useEffect, useState, useMemo } from 'react';
import { useAppState } from '../context/State';
import { GetCopy } from '../util/GetCopy';
import { getFirstAvailableSize, getSizeToChoose } from '../utils/dataTransformations';

export const AdSize = ({ brandData, currentSize, setCurrentSize, selected, screenSizeHasAdSize }) => {
  const state = useAppState();
  const sizes = state.adSizes;
  
  const firstAvailableSize = useMemo(() => 
    getFirstAvailableSize(brandData, state.adSizes, screenSizeHasAdSize), 
    [brandData, state.adSizes, screenSizeHasAdSize]
  );
  
  const sizeToChoose = useMemo(() => 
    getSizeToChoose(brandData, firstAvailableSize), 
    [brandData, firstAvailableSize]
  );

  const setSize = (e) => {
    setCurrentSize(e);
  };
  
  // Note: Automatic size selection is now handled in BrandBody component
  return (
    <div>
      <b>
        <GetCopy copy="ad size" />
      </b>
      {!brandData['16:9'] && (
        <div className="adSizeHolder">
          {sizes.map((size) => {
            const available = !!brandData[size];
            const activeOrNot = size === currentSize ? 'adSizeText active' : 'adSizeText';
            const mobile =
              selected === 'Mobile' && (currentSize === '300x600' || currentSize === '300x250') && 'mobileSize';

            if (available && screenSizeHasAdSize.includes(size)) {
              return (
                <span
                key={size}
                  onClick={() => {
                    setSize(size);
                  }}
                  className={`${activeOrNot} ${mobile}`}
                >
                  {size}
                </span>
              );
            } else {
              return;
            }
          })}
        </div>
      )}
      {!!brandData['16:9'] && (
        <div className="adSizeHolder">
          <span
            onClick={() => {
              // theres only one size for ctv
              // setSize("16:9");
            }}
            className={'adSizeText active'}
          >
            16:9
          </span>
        </div>
      )}
    </div>
  );
};
